module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Karang-Nini-ae24ba36e8fdce5c4c18fd299c1d584a.jpg";